export const USABILLA_ID = '03a749f8938f'
export const USABILLA_ORDER_COMPLETION_FEEDBACK_WIDGET_ID =
  '5f4711af92eb7204a401af62'
